import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { PumpSymbol } from '../primitives/PumpSymbol';
import { DT } from '../tokens';

/** Pump BHP = WHP / η_pump — motor + coupling + pump with input/output gauges. */
export function DiagramPumpBrakeHP() {
  return (
    <DiagramCanvas>
      {/* Motor */}
      <Rect x={30} y={95} width={90} height={70} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" rx="4" />
      {Array.from({ length: 6 }).map((_, i) => (
        <Line key={i} x1={30} y1={99 + i * 11} x2={120} y2={99 + i * 11}
          stroke={DT.stroke} strokeWidth="0.4" opacity={0.4} />
      ))}
      <SvgText x={75} y={134} fill={DT.desc} fontSize="9" fontFamily={DT.mono} textAnchor="middle">MOTOR</SvgText>

      {/* Coupling */}
      <Line x1={120} y1={130} x2={155} y2={130} stroke={DT.stroke} strokeWidth="5" />
      <Rect x={130} y={123} width={14} height={14} fill={DT.fill} stroke={DT.stroke} strokeWidth="1" />

      {/* Pump (centrifugal) */}
      <Circle cx={195} cy={130} r={32} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" />
      {/* Volute outline */}
      <Path d={`M163,130 A32,32 0 1 1 195,162 L240,162 L240,150 L227,150`}
        fill="none" stroke={DT.stroke} strokeWidth="1.2" />
      {/* Impeller */}
      {[0, 60, 120, 180, 240, 300].map(deg => {
        const rad = deg * Math.PI / 180;
        return (
          <Line key={deg} x1={195 + 6 * Math.cos(rad)} y1={130 + 6 * Math.sin(rad)}
            x2={195 + 22 * Math.cos(rad + 0.4)} y2={130 + 22 * Math.sin(rad + 0.4)}
            stroke={DT.stroke} strokeWidth="1.4" />
        );
      })}
      <Circle cx={195} cy={130} r={5} fill={DT.stroke} />

      {/* Suction pipe */}
      <Line x1={155} y1={130} x2={163} y2={130} stroke={DT.stroke} strokeWidth="6" />
      {/* Discharge pipe */}
      <Line x1={240} y1={156} x2={310} y2={156} stroke={DT.stroke} strokeWidth="6" />
      <Polygon points={`310,156 304,152 304,160`} fill={DT.arrow} />

      {/* Input W gauge (motor electrical input) */}
      <Circle cx={75} cy={62} r={12} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.4" />
      <SvgText x={75} y={66} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">HP</SvgText>
      <Line x1={75} y1={74} x2={75} y2={95} stroke={DT.leader} strokeWidth="0.8" strokeDasharray="2,2" />

      {/* η_pump efficiency annotation on pump */}
      <SvgText x={195} y={106} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">η_pump</SvgText>

      {/* WHP gauge (water output) */}
      <Circle cx={290} cy={62} r={12} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.4" />
      <SvgText x={290} y={66} fill={DT.varColor} fontSize="8" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">WHP</SvgText>
      <Line x1={290} y1={74} x2={290} y2={156} stroke={DT.leader} strokeWidth="0.8" strokeDasharray="2,2" />

      {/* Labels */}
      <LeaderLine x1={75} y1={50} x2={20} y2={210} varName="HP_input" desc="motor electrical" anchor="start" />
      <LeaderLine x1={137} y1={130} x2={140} y2={210} varName="BHP" desc="shaft (brake) HP" anchor="middle" />
      <LeaderLine x1={290} y1={50} x2={310} y2={210} varName="WHP" desc="water HP delivered" anchor="end" />

      <FormulaTag formula="BHP = WHP / η_pump   (HP_motor = BHP / η_motor)" />
    </DiagramCanvas>
  );
}
